import { GEMINI_CONFIG, GeminiGenerateContentRequest } from '@/config/gemini'
import { supabase } from '@/config/supabase'

class GeminiService {
  private enabled: boolean
  private languageNameByCode: Record<string, string> = {
    en: 'English',
    tr: 'Turkish',
    de: 'German',
    fr: 'French',
    es: 'Spanish',
    it: 'Italian',
    ru: 'Russian',
    ar: 'Arabic',
    ja: 'Japanese',
    ko: 'Korean',
    zh: 'Chinese',
  }

  constructor() {
    // API key check is no longer needed on frontend as it's handled by Edge Function
    this.enabled = GEMINI_CONFIG.enabled
  }

  isEnabled(): boolean {
    return this.enabled
  }

  async translate(text: string, targetLang: string = 'en', sourceLangHint?: string): Promise<string> {
    if (!this.enabled) return text

    const targetName = this.languageNameByCode[targetLang] || targetLang
    const sourceName = sourceLangHint ? (this.languageNameByCode[sourceLangHint] || sourceLangHint) : 'Auto-detect'

    const prompt = `You are a precise translation assistant.
Translate the following text into high-quality, fluent ${targetName} (${targetLang}).
- Do not add or remove meaning.
- Preserve proper nouns, style terms, commas and descriptive phrases.
- If the text is already in ${targetName}, return it unchanged.
- Source language: ${sourceName}.

Text:\n"""${text}"""

${targetName}:`

    const body: GeminiGenerateContentRequest = {
      contents: [
        {
          role: 'user',
          parts: [{ text: prompt }],
        },
      ],
    }

    const { data, error } = await supabase.functions.invoke('ai-proxy', {
      body: {
        action: 'gemini-translate',
        payload: body
      }
    })

    if (error) {
      throw new Error(`Gemini API error via Edge Function: ${error.message}`)
    }
    const candidate = data.candidates?.[0]?.content?.parts?.[0]?.text?.trim()
    return candidate && candidate.length > 0 ? candidate : text
  }
  
}

export const geminiService = new GeminiService()
export default geminiService


